// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-544b8e5c]{\n  list-style-type:disc;\n  margin-left:1rem;\n  padding:0\n}\nul li[data-v-544b8e5c]{\n  text-align:left\n}\nul li>*[data-v-544b8e5c]{\n  vertical-align:initial\n}\nul li button[data-v-544b8e5c]{\n  vertical-align:top\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
